export default {
  apiUrl: '//vod-test.wix.com/',
  filesUrl: '//vod-meta-test.wix.com/',
  mediaType: 'secure_video',
};



// WEBPACK FOOTER //
// ./src/transport/adapters/vod/default-settings.js